export enum StorageKey {

    SCREEN_CODE = 'SCREEN_CODE'
}

export default StorageKey;